import React from 'react';
import { PrimaryButton, LinkButton } from 'components/lib/buttons/Button';
import styles from 'styles/components/lib/tables/dnd/dndBucketFooter.css';


const DnDBucketFooter = ({errorMessage, isEditing, isEmpty, isNewBucket, color, ...props}) => {
  let onCancelFunction = () => {
    if (props.onCancel) props.onCancel();
    if (props.onNewNameChange)  props.onNewNameChange('');
  }
  return (
    <nav className={styles.dndBucketFooter}>
      {isEditing &&
      <ul className={styles.list}>
        <li key="0">
          <PrimaryButton
            label="Save"
            disabled={isNewBucket ? !props.name : errorMessage ? true : props.isEmptyName}
            onClick={isNewBucket
              ? (e) => {
                props.onSubmit(e, props.name);
                props.onNewNameChange('');
              }
              : (e) => {
                props.onClickEdit(e)
              }}
            style={isNewBucket
              ? { backgroundColor: !props.name ? "#CCCCCC" : "#888888", cursor: !props.name ? 'default' : 'pointer' }
              : errorMessage
                ? { backgroundColor: '#CCCCCC', cursor: 'default'}
                : {
                    backgroundColor: props.isEmptyName ? "#CCCCCC" : "#888888",
                    cursor: props.isEmptyName ? 'default' : 'pointer'
                  }
            }/>
        </li>
        <li key="1">
          <LinkButton
            label="Cancel"
            onClick={onCancelFunction}
            style={{ color: "#888888", padding: '3px 30px' }}/>
        </li>
      </ul>
      }
    </nav>
  );
}
export default DnDBucketFooter;



// WEBPACK FOOTER //
// ./src/scripts/components/lib/tables/dnd/DnDBucketFooter.js